export const copyTextToClipboard = async (text: string) => {
  try {
    if ((navigator as any).clipboard) {
      if (typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(text);
        return text;
      } else {
        alert('Reading from clipboard is not supported in this browser.');
        return null;
      }
    } else {
      alert(
        'Secure context: This feature is available only in secure contexts (HTTPS), in some or all supporting browsers.'
      );
      return null;
    }
  } catch {
    alert(
      "We couldn't automatically copy to your clipboard because your browser blocked the action."
    );
    return null;
  }
};

export const getClipboardContents = async () => {
  try {
    if ((navigator as any).clipboard && typeof navigator.permissions !== 'undefined') {
      const permission = await navigator.permissions.query({
        name: 'clipboard-read' as PermissionName
      });

      if (permission.state === 'denied') {
        alert('Clipboard read permission denied');
        return null;
      }

      const text = await navigator.clipboard.readText();

      return text;
    } else {
      alert(
        'Secure context: This feature is available only in secure contexts (HTTPS), in some or all supporting browsers.'
      );
      return null;
    }
  } catch {
    alert(
      "We couldn't automatically copy to your clipboard because your browser blocked the action."
    );
    return null;
  }
};

export const removeHtmlTags = (text?: string) => {
  if (!text) return '';

  return text
    .replace(/<\/p>/gi, ' ') // Replace closing </p> with space
    .replace(/(<([^>]+)>)/gi, '') // Strip all other tags
    .replace(/&nbsp;/g, ' ') // Convert all &nbsp; to space
    .replace(/\s+/g, ' ') // Collapse multiple spaces and nbsp into one
    .trim(); // Trim start and end
};

// after removing the first \n which is automatically added by the AI, replace all others with <br />
export const formatTextWithLineBreaks = (text: string) => {
  return text.replace('\n', '').replace(/\n/g, '<br />');
};

export const snakeCaseToTitleCase = (value: string): string =>
  value.replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase());
